//@ts-nocheck
import { ExternalLinkIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Box,
  Button,
  Divider,
  Flex,
  HStack,
  Icon,
  Input,
  Link,
  ListItem,
  Progress,
  Stack,
  Text,
  UnorderedList,
  useToast,
  Modal,
  ModalContent,
  ModalBody,
  Center,
} from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { FiVideo } from "react-icons/fi";
import { RiVideoUploadFill } from "react-icons/ri";
import { FaWhatsapp } from "react-icons/fa";
import { XButton } from "../../components/ui-elements/Icon";
import Upload from "../../components/Upload";
import VerificationWrapper, {
  useTutorApplicationFlow,
} from "../../components/VerificationWrapper";
import { IEducationWorkHistoryStore, IRootStore } from "../../stores";
import { STEPS } from "../../stores/rootStore";
import { IOtherStore } from "../../stores/types";
import { samplePromise } from "../../testAdapter";
import TutorPageWrapper from "../../tutor-revamp";
import VerificationIdentity from "../../tutor-revamp/VerificationIdentity";
import VideoUploader, {
  YoutubeLinkUpload,
} from "../../tutor-revamp/VideoUploader";
import { scrollToId } from "../../utils/functions";
import { useInterval } from "../../utils/hooks";
import { VideoPlayer } from "../../_new_/components";

const VerificationUploadComponent: React.FC<{
  histories: Array<any>;
  component: any;
}> = ({ histories, component }) => {
  let Component = component;
  return (
    <Box>
      {histories.map((form, index) => {
        return (
          <Box key={index}>
            <Component field={form}>
              <Upload
                maxSize={2097152}
                allowMultiple={false}
                store={histories[index].upload}
              >
                <XButton
                  size="sm"
                  leftIcon={"upload"}
                  variant="link"
                  colorScheme="green"
                >
                  Upload
                </XButton>
              </Upload>
            </Component>
            {index !== histories.length - 1 && (
              <Divider borderColor="neutral.500" my={[5, 6]} />
            )}
          </Box>
        );
      })}
    </Box>
  );
};

const WorkHistoryVerification: React.FC<{
  field: any;
  children: React.ReactElement;
}> = ({ field: workHistory, children }) => {
  const { company, role } = workHistory;

  return (
    <Box>
      {company && (
        <Flex justify="space-between" align="baseline">
          <Box flex={1}>
            <Text fontWeight="semibold">{role}</Text>
            <Text>{company}</Text>
          </Box>

          <Stack ml={[0, 6]} align="center">
            {children}
          </Stack>
        </Flex>
      )}
    </Box>
  );
};

const EducationVerification: React.FC<{
  field: {
    school: string;
    country: string;
    course: string;
    degree: string;
    startYear: string;
    endYear: string;
    grade: string;
  };
  children: React.ReactElement;
}> = observer(({ field: education, children }) => {
  const { school, course, degree } = education;

  return (
    <Box>
      {school && (
        <Flex justify="space-between" align="baseline">
          <Box flex={1}>
            <Text fontWeight="semibold">
              {degree}, {course}
            </Text>
            <Text>{school}</Text>
          </Box>

          <Stack ml={[0, 6]} align="center">
            {children}
          </Stack>
        </Flex>
      )}
    </Box>
  );
});
let styles = {
  p: [8, 10],
  borderWidth: "2xs",
  borderRadius: "lg",
  borderColor: "neutral.500",
};
export type VideoUploadProps = {
  onSubmit: () => Promise<any>;
  videoSummary: {
    id?: string;
    url?: string;
    status?: string;
  };
  introVideo?: string;
  generateInterviewLink: () => Promise<{ id: string; url: string }>;
  whatsappProps: {
    manualApproval: boolean;
    agentName: string;
    agentContact: string;
    tutorName: string;
    tutorEmail: string;
    tutorSlug: string;
  };
  whatsappRecord: () => Promise<any>;
};
type HireflixEventShape = {
  /**
   * The type of the event.
   */
  type: string;
  /**
   * Some events contain a payload which is always in an object shape.
   */
  payload?: Record<string, unknown>;
  /**
   * The description of the event.
   */
  description?: string;
};
export const VideoUploadSection: React.FC<VideoUploadProps> = observer(
  ({
    videoSummary,
    introVideo = "https://youtu.be/eGeFbHX-V9A",
    generateInterviewLink,
    onSubmit,
    whatsappProps,
    whatsappRecord,
  }) => {
    const { manualApproval, agentName, agentContact, tutorName, tutorEmail } =
      whatsappProps;

    const [videoFinished, setVideoFinished] = useState<boolean>(false);
    const [duration, setDuration] = useState<number>(0);
    const [progress, setProgress] = useState<number>(
      videoSummary.status ? 100 : 0
    );
    const [videoState, setVideoState] = useState<{
      id?: string;
      status?: string;
      url?: string;
    }>(videoSummary);
    const [isLoading, setLoading] = useState(false);
    const [whatsAppLoading, setWhatsAppLoading] = useState<boolean>(false);
    const [hasBrowserIssue, setHasBrowserIssue] = useState<boolean>(false);
    const [openIframe, setOpenIframe] = useState(false);

    const videoRecordingLink = videoSummary.status !== "";
    async function beginRecording() {
      setLoading(true);
      const payload: any = await generateInterviewLink();
      setVideoState(payload);
      setOpenIframe(true);
      // other action to trigger like the iframe
    }
    const onEventReceived = React.useCallback(
      (event: MessageEvent<HireflixEventShape>) => {
        if (videoState?.url && videoState.url.includes(event.origin)) {
          if (event.data.type === "interview.finished") {
            setOpenIframe(false);
            setVideoState({ ...videoState, status: "completed" });
            // onSubmit(videoState.id as string);
          }
        }
      },
      [videoState, setVideoState]
    );
    React.useEffect(() => {
      // Attach an event listener to listen for events
      window.addEventListener("message", onEventReceived);
      return () => {
        window.removeEventListener("message", onEventReceived);
      };
    }, [onEventReceived]);

    const isCompleted = manualApproval
      ? manualApproval
      : ["completed", "finalist", "archived"].includes(
          videoState?.status || ""
        );

    const whatsappUrl = `https://wa.me/${agentContact}?text=Hi%20${encodeURIComponent(agentName)},%20My%20name%20is%20${encodeURIComponent(tutorName)},%20my%20email%20address%20is%20${encodeURIComponent(tutorEmail)}.%20I%20want%20to%20submit%20my%20video%20interview%20for%20your%20review.`;

    return (
      <Stack spacing={6}>
        <Stack id="form-header-section">
          <Text fontWeight="bold" fontSize={["3xl", "4xl"]}>
            Video interview
          </Text>
          <Text color="gray.700">
            Well done! You're almost there. To submit your application, you'll
            need to record a video interview to help us know you better. Watch
            the video guide below to learn more.
          </Text>
        </Stack>
        <Box>
          <Box width="100%">
            <Box
              height={{ base: "2xs", sm: "xs" }}
              overflow="hidden"
              roundedTop="lg"
            >
              <VideoPlayer
                controls={false}
                playing={false}
                pip={false}
                url={introVideo}
                onEnded={() => setVideoFinished(true)}
                onDuration={(d) => setDuration(d)}
                onProgress={({ playedSeconds }) => {
                  const currentProgress = (playedSeconds / duration) * 100;
                  if (!videoRecordingLink || !videoFinished) {
                    setProgress(currentProgress);
                  }
                }}
              />
            </Box>
            <Progress
              bg="gray.300"
              height="6px"
              borderRadius="none"
              size="sm"
              value={Math.round(progress)}
            />
          </Box>

          {isCompleted ? (
            <Box>
              <Alert
                status="success"
                variant="subtle"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                height="200px"
              >
                <AlertIcon as={FiVideo} boxSize="40px" mr={0} />
                <AlertTitle mt={4} mb={1} fontSize="lg">
                  Video submitted!
                </AlertTitle>
                <AlertDescription maxWidth="sm">
                  Thanks for submitting your video. Our team will get back to
                  you soon.
                </AlertDescription>
              </Alert>
              <Button
                size="lg"
                alignSelf="center"
                px={12}
                isFullWidth
                mt={6}
                colorScheme="blue"
                onClick={onSubmit}
              >
                Save and Continue
              </Button>
            </Box>
          ) : (
            <Flex
              borderWidth="2xs"
              direction="column"
              // textAlign={"center"}
              borderColor="neutral.500"
              px={[4, 6]}
              py={6}
              roundedBottom="lg"
              bg="neutral.200"
              gap={6}
            >
              <Stack maxWidth={["100%", "100%"]} mx="auto">
                <Text fontSize={{ base: "1rem" }}>
                  <Text display="inline-block" fontWeight="semibold">
                    Interview Question:
                  </Text>{" "}
                  Share a story or personal experience that has influenced your
                  perspective to tutoring. How would you use this experience to
                  inspire and educate a student who is struggling to find
                  interest in the subjects you teach?
                </Text>
              </Stack>

              <Flex
                width="full"
                flexDir={{ base: "column-reverse", md: "row" }}
                alignItems={{ base: "center", md: "flex-end" }}
                justifyContent={{
                  base: "center",
                  md: hasBrowserIssue ? "space-between" : "center",
                }}
                gap={{ base: "0.75em", md: "0.5em" }}
              >
                <Flex
                  flexDir="column"
                  align="center"
                  justify="center"
                  width={{ base: "full", md: "47%" }}
                  maxWidth={{ sm: "300px" }}
                  display={{
                    base: "block",
                    md: hasBrowserIssue ? "block" : "none",
                  }}
                >
                  <Text
                    textAlign="center"
                    mb="0.5em"
                    fontSize={{ base: "0.75rem" }}
                    display={{
                      base: "none",
                      md: "block",
                    }}
                  >
                    Having issues recording on the browser?
                  </Text>
                  <Button
                    width="full"
                    size="lg"
                    alignSelf="center"
                    px={12}
                    bg="white"
                    color="#20b858"
                    outline="1px solid #20b858"
                    _hover={{
                      bg: "#1da548",
                      color: "white",
                      outline: "1px solid transparent",
                    }}
                    variant="outline"
                    isLoading={whatsAppLoading}
                    isDisabled={!videoFinished && !videoRecordingLink}
                    rightIcon={<FaWhatsapp />}
                    onClick={async () => {
                      setWhatsAppLoading(true);
                      whatsappRecord()
                        .then(() => {
                          console.log(
                            `Marked ${tutorName}'s video as completed`
                          );
                        })
                        .catch((error) => {
                          console.error(
                            `Error marking ${tutorName}'s video as completed:`,
                            error
                          );
                        })
                        .finally(() => {
                          window.open(whatsappUrl, "_blank");
                          setWhatsAppLoading(false);
                        });
                    }}
                  >
                    Record on Whatsapp
                  </Button>
                </Flex>

                <Flex
                  flexDir="column"
                  alignItems="center"
                  justify="center"
                  gap={{ base: "0.75em", md: "0.5em" }}
                  width={{
                    base: "full",
                    md: hasBrowserIssue ? "47%" : "100%",
                  }}
                  maxWidth={{ sm: "300px" }}
                >
                  <Button
                    width="full"
                    size="lg"
                    alignSelf="center"
                    px={12}
                    colorScheme="blue"
                    variant="solid"
                    isLoading={isLoading}
                    isDisabled={!videoFinished && !videoRecordingLink}
                    rightIcon={<ExternalLinkIcon />}
                    onClick={beginRecording}
                  >
                    Record on Browser
                  </Button>
                  <Center
                    display={{ base: "flex", md: "none" }}
                    width="full"
                    justify="space-between"
                    gap="1em"
                  >
                    <Divider borderColor="neutral.700" />
                    or
                    <Divider borderColor="neutral.700" />
                  </Center>
                  <Text
                    fontSize={{ base: "0.75rem" }}
                    onClick={() => setHasBrowserIssue(true)}
                    cursor="pointer"
                    textDecor="underline"
                    display={{
                      base: "none",
                      md: !hasBrowserIssue ? "block" : "none",
                    }}
                  >
                    Having issues recording on the browser?
                  </Text>
                </Flex>
              </Flex>
            </Flex>
          )}
          <Modal isOpen={openIframe} onClose={() => {}} size="full">
            <ModalContent>
              <ModalBody p="0">
                <Box
                  as={"iframe"}
                  id="inlineFrameExample"
                  title="Inline Frame Example"
                  width="100vw"
                  height="100vh"
                  src={videoState.url}
                  allow="camera https://app.hireflix.com; microphone https://app.hireflix.com"
                />
              </ModalBody>
            </ModalContent>
          </Modal>
        </Box>

        {/* <Box
          borderWidth="2xs"
          borderColor="neutral.500"
          px={[6, 6]}
          py={[6, 8]}
          rounded="lg"
          bg="neutral.200"
        >
          {youtubeView ? (
            <YoutubeLinkUpload
              onSubmit={() => onSubmit(store.youtubeValues)}
              onSwitchClick={() => switchView(false)}
              videoUrl={store.videoSummary.url}
              setVideoUrl={store.setVideoUrl}
              loading={store.loading}
            />
          ) : (
            <>
              <VideoUploader
                onSubmit={onSubmit}
                cloudinaryProps={rootStore.cloudinaryProps}
                uploaded={store.videoSummary.completed}
                generateVideoUrl={store.submitVideoRecording}
                loading={rootStore.loading}
                // videoUrl={store.videoSummary.url}
                onError={onError}
              >
                <Stack
                  maxWidth={["100%", "60%"]}
                  mx="auto"
                  mb={6}
                  textAlign={"center"}
                >
                  <Text fontWeight="bold" fontSize="lg">
                    Upload Video
                  </Text>
                  <Text color="gray.600">
                    Select a recorded video to upload
                  </Text>
                </Stack>
              </VideoUploader>
            </>
          )}
        </Box> */}
      </Stack>
    );
  }
);

// export type VideoUploadProps = {
//   loading: boolean;
//   store: IOtherStore;
//   rootStore: IRootStore;
//   onSubmit: (url) => Promise<any>;
//   onError?: any;
//   videoRecordingLink?: string;
// };
export const OldVideoUploadSection: React.FC<VideoUploadProps> = observer(
  ({
    loading,
    store,
    rootStore,
    onSubmit,
    onError,
    videoRecordingLink = "https",
  }) => {
    const [youtubeView, switchView] = useState(false);
    const [videoFinished, setVideoFinished] = useState<boolean>(false);
    const [duration, setDuration] = useState<number>(0);
    const [progress, setProgress] = useState<number>(
      videoRecordingLink ? 100 : 0
    );

    return (
      <Stack spacing={6}>
        <Stack id="form-header-section">
          <Text fontWeight="bold" fontSize={["3xl", "4xl"]}>
            Video interview
          </Text>
          <Text color="gray.700">
            Well done! You're almost there. To submit your application, you'll
            need to record a video interview to help us know you better. Watch
            the video guide below to learn more.
          </Text>
        </Stack>

        <Box>
          <Box width="100%">
            <Box
              height={{ base: "2xs", sm: "xs" }}
              overflow="hidden"
              roundedTop="lg"
            >
              <VideoPlayer
                controls={false}
                playing={false}
                pip={false}
                url="https://youtu.be/Kd7sHK-q8ec"
                onEnded={() => setVideoFinished(true)}
                onDuration={(d) => setDuration(d)}
                onProgress={({ playedSeconds }) => {
                  const currentProgress = (playedSeconds / duration) * 100;
                  if (!videoRecordingLink || !videoFinished) {
                    setProgress(currentProgress);
                  }
                }}
              />
            </Box>
            <Progress
              bg="gray.300"
              height="6px"
              borderRadius="none"
              size="sm"
              value={Math.round(progress)}
            />
          </Box>

          {store.videoSummary.completed ? (
            <Alert
              status="success"
              variant="subtle"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              height="200px"
            >
              <AlertIcon as={FiVideo} boxSize="40px" mr={0} />
              <AlertTitle mt={4} mb={1} fontSize="lg">
                Video submitted!
              </AlertTitle>
              <AlertDescription maxWidth="sm">
                Thanks for submitting your video. Our team will get back to you
                soon.
              </AlertDescription>
            </Alert>
          ) : (
            <Flex
              borderWidth="2xs"
              direction="column"
              textAlign={"center"}
              borderColor="neutral.500"
              px={6}
              py={6}
              roundedBottom="lg"
              bg="neutral.200"
              gap={6}
            >
              <Stack maxWidth={["100%", "60%"]} mx="auto">
                <Text fontWeight="bold" fontSize="lg">
                  {videoFinished || videoRecordingLink
                    ? "Record your video"
                    : "Watch video guide"}
                </Text>
                <Text color="gray.600">
                  {videoFinished || videoRecordingLink
                    ? "Click below to record your video"
                    : "You can start recording your video after watching the guide"}
                </Text>
              </Stack>

              <Button
                size="lg"
                alignSelf="center"
                px={12}
                colorScheme="blue"
                isDisabled={!videoFinished && !videoRecordingLink}
                rightIcon={<ExternalLinkIcon />}
                {...(videoRecordingLink && {
                  as: "a",
                  href: videoRecordingLink,
                  target: "_blank",
                })}
              >
                Start recording
              </Button>
            </Flex>
          )}
        </Box>

        {/* <Box
          borderWidth="2xs"
          borderColor="neutral.500"
          px={[6, 6]}
          py={[6, 8]}
          rounded="lg"
          bg="neutral.200"
        >
          {youtubeView ? (
            <YoutubeLinkUpload
              onSubmit={() => onSubmit(store.youtubeValues)}
              onSwitchClick={() => switchView(false)}
              videoUrl={store.videoSummary.url}
              setVideoUrl={store.setVideoUrl}
              loading={store.loading}
            />
          ) : (
            <>
              <VideoUploader
                onSubmit={onSubmit}
                cloudinaryProps={rootStore.cloudinaryProps}
                uploaded={store.videoSummary.completed}
                generateVideoUrl={store.submitVideoRecording}
                loading={rootStore.loading}
                // videoUrl={store.videoSummary.url}
                onError={onError}
              >
                <Stack
                  maxWidth={["100%", "60%"]}
                  mx="auto"
                  mb={6}
                  textAlign={"center"}
                >
                  <Text fontWeight="bold" fontSize="lg">
                    Upload Video
                  </Text>
                  <Text color="gray.600">
                    Select a recorded video to upload
                  </Text>
                </Stack>
              </VideoUploader>
            </>
          )}
        </Box> */}
      </Stack>
    );
  }
);

export const VerifyEmailSection: React.FC<{
  store: IRootStore;
  onSubmit: any;
}> = observer(({ store, onSubmit }) => {
  const toast = useToast();
  const [emailSent, sendEmail] = React.useState(false);
  const [countDown, setCountdown] = React.useState(60);
  const [loading, setLoading] = React.useState(false);
  const [sendingCode, setSendingCode] = React.useState(false);
  const [code, setCode] = React.useState("");
  useInterval(() => {
    if (emailSent) {
      if (countDown <= 0) {
        sendEmail(false);
      }
      setCountdown(countDown - 1);
    }
  }, 1000);
  async function onSendEmail() {
    if (!emailSent) {
      try {
        setSendingCode(true);
        await store.sendEmailVerification();
        toast({
          status: "success",
          title: "Email Sent",
          description: "Code sent to email",
          isClosable: true,
          duration: 2000,
        });
        setSendingCode(false);
        sendEmail(true);
        setCountdown(60);
      } catch (error) {
        toast({
          status: "error",
          title: "Error sending code",
          description: "An error occured!.",
          isClosable: true,
          duration: 2000,
        });
        setSendingCode(false);
      }
    }
  }
  async function onSubmitCode() {
    try {
      setLoading(true);
      console.log(code);
      let result = await store.sendEmailVerification(code);
      if (result) {
        toast({
          status: "success",
          title: "Email verified",
          description: "Email verified",
          isClosable: true,
          duration: 2000,
        });
        await onSubmit({ emailVerified: result });
      } else {
        toast({
          status: "error",
          title: "Email verification failed",
          description: "The code doesn't match",
          isClosable: true,
          duration: 2000,
        });
      }
      setLoading(false);
    } catch (error) {
      toast({
        status: "error",
        title: "Error verifying email",
        description: "An error occured!",
        isClosable: true,
        duration: 2000,
      });
      setLoading(false);
    }
  }
  if (store.emailVerified) return <div />;
  return (
    <Box {...styles}>
      <Stack mb={6} id="form-header-section">
        <Text fontWeight="bold" fontSize={["3xl", "4xl"]}>
          Verify your email
        </Text>
        <Text color="gray.700">
          We've sent you a code. Please check your inbox, copy the code and
          paste it here to verify your email so that we can keep in touch.
        </Text>
      </Stack>

      <Stack mb={4} spacing={4} direction={["column", "row"]}>
        <Input
          value={code}
          borderColor="neutral.500"
          size="lg"
          onChange={(e) => {
            setCode(e.target.value);
          }}
          type={"text"}
          placeholder="Enter code"
        />
        <Button
          colorScheme={"blue"}
          onClick={onSubmitCode}
          loadingText="Sending"
          isLoading={loading}
          size="lg"
          isDisabled={!Boolean(code)}
        >
          Verify
        </Button>
      </Stack>

      <HStack>
        <Text>Didn't get the code?</Text>
        <Button
          variant="link"
          colorScheme="blue"
          isLoading={sendingCode}
          loadingText="Sending"
          isDisabled={emailSent}
          onClick={onSendEmail}
        >
          {emailSent ? countDown : "Re-send"}
        </Button>
      </HStack>
    </Box>
  );
});

export const VerifyWorkHistorySection: React.FC<{
  store: IEducationWorkHistoryStore;
}> = observer(({ store }) => {
  return (
    <Box {...styles}>
      <Box mb={6} textAlign={"center"}>
        <Text fontSize="24px" fontWeight="bold">
          Work experience verification
        </Text>
        <Text color="neutral.700">
          Verify your work experience by uploading proof of experience
        </Text>
      </Box>
      <VerificationUploadComponent
        histories={store.workHistories}
        component={WorkHistoryVerification}
      />
    </Box>
  );
});

export const VerifyEducationSection: React.FC<{
  store: IEducationWorkHistoryStore;
}> = observer(({ store }) => {
  return (
    <Box {...styles}>
      <Box mb={6} textAlign={"center"}>
        <Text fontSize="24px" fontWeight="bold">
          Education history verification
        </Text>
        <Text color="neutral.700">
          Verify your education by uploading proof like certificates or
          transcripts
        </Text>
      </Box>
      <VerificationUploadComponent
        histories={store.educations}
        component={EducationVerification}
      />
    </Box>
  );
});

const VerificationPage: React.FC<{
  store: IRootStore;
  onNextStep?: () => void;
  currentStep?: string;
  onLogout?: () => any;
  getInterviewLink: () => Promise<string>;
}> = ({ store, onNextStep, currentStep, onLogout, getInterviewLink }) => {
  const { getFormWrapperProps, formIndex, steps, activeStep, completedForm } =
    useTutorApplicationFlow(store, currentStep);
  const [displayError, setErrorState] = React.useState(false);
  async function onSubmitStep() {
    if (store.verificationStepsWithError.length === 0) {
      setErrorState(false);
      onNextStep();
    } else {
      setErrorState(true);
      scrollToId("verificationErrors");
    }
  }

  React.useEffect(() => {
    if (store.verificationStepsWithError.length === 0 && displayError) {
      setErrorState(false);
    }
  }, [store.verificationStepsWithError.length, displayError]);
  let videoUploadProps = getFormWrapperProps(STEPS.VIDEO_SUMMARY);
  return (
    <TutorPageWrapper onLogout={onLogout} id="verificationErrors">
      {displayError ? (
        <Stack
          borderWidth="xs"
          spacing={3}
          borderColor="red"
          bg="red.50"
          rounded="lg"
          color="red.500"
          px={[6, 8]}
          py={5}
        >
          <Text fontSize="lg" fontWeight="semibold">
            Please complete the following sections
          </Text>
          <Box pl={3}>
            <UnorderedList fontWeight="medium" spacing={3}>
              {store.verificationStepsWithError.map((err) => {
                return <ListItem key={err}>{err}</ListItem>;
              })}
            </UnorderedList>
          </Box>
        </Stack>
      ) : null}
      <VerificationWrapper
        rootStore={store}
        currentEditableForm={activeStep}
        activeForm={formIndex}
      >
        <VerificationIdentity {...getFormWrapperProps(STEPS.VERIFICATION)} />
        <VideoUploadSection
          {...videoUploadProps}
          rootStore={store}
          onError={store.notifyServerForError}
          onSubmit={(d: any) => {
            return videoUploadProps.onSubmit(d, STEPS.VIDEO_SUMMARY);
          }}
        />
      </VerificationWrapper>
      <Button
        colorScheme={"blue"}
        onClick={onSubmitStep}
        height={["48px", "64px"]}
        size="lg"
        // rightIcon={<ChevronRightIcon fontSize="2xl" />}
        isLoading={store.applicationLoading}
        loadingText="Submitting..."
      >
        Submit Application
      </Button>
    </TutorPageWrapper>
  );
};

export default observer(VerificationPage);
